import "features/bulletins/assets/styles/BulletinTeaser.scss";
import Labels from "components/ui/Labels/Labels";
import ResponsiveImage from "components/ui/ResponsiveImage/ResponsiveImage";
import { useState } from "react";
import ButtonLike from "features/likes/components/ButtonLike/ButtonLike";
import { useHistory } from "react-router-dom";
import ParticipationStatusBar from "components/ui/ParticipationStatusBar/ParticipationStatusBar";
import Button from "components/ui/Button/Button";

function MonthlyHighlightTeaser({ data }) {
  const history = useHistory();
  const [ likeCount, setLikeCount ] = useState(0);

  return (
    <div className={ `teaser teaser-highlight` }>
      <div className={ 'teaser__inner' }>
        <div className={ 'teaser__actions' }>
          <Labels items={ [ data.month ] }/>
          <ButtonLike
            entityId={ parseInt(data.nid) }
            entityType={ `bulletin` }
            onReceivedCount={ (count) => setLikeCount(count) }
          />
        </div>

        <div className={ 'teaser__title' }>
          <h3 className={ 'pointer' } onClick={ () => history.push(data.url) }>{ data.title }</h3>
        </div>

        {
          data.field_bulletin_image &&
          <div className={ 'teaser__image teaser-highlight__image' }>
            <ResponsiveImage value={ data.field_bulletin_image }/>
          </div>
        }

        <div className={ 'teaser__intro' }>
          { data.field_description }
        </div>

        <div className={ 'teaser__buttons' }>
          <Button onClick={ () => history.push(data.url) } variant={ 'secondary' } className={ 'button--small' }>
            Bekijk
          </Button>
        </div>

        <ParticipationStatusBar
          likeCount={ likeCount }
          commentCount={ Number(data.comment_count) }
          variant={ `teaser` }
        />
      </div>

      <span className={ 'link-overlay' } onClick={ () => history.push(data.url) }></span>
    </div>
  );
}

export default MonthlyHighlightTeaser;
